import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=58c53f64&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.vue?vue&type=style&index=0&id=58c53f64&prod&lang=less&scoped=true"
import style1 from "./Aside.vue?vue&type=style&index=1&id=58c53f64&prod&lang=less&scoped=true"
import style2 from "./Aside.vue?vue&type=style&index=2&id=58c53f64&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c53f64",
  null
  
)

export default component.exports